export default __webpack_public_path__ + "static/media/profilePhoto.5c0607de.jpg";